(() => {
  const JST_OFFSET_MINUTES = 9 * 60;

  const parseJstDate = (value, isEnd = false) => {
    if (!value) return null;

    const input = String(value).trim();
    if (!input) return null;

    if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(input)) {
      const parsed = Date.parse(input);
      return Number.isNaN(parsed) ? null : parsed;
    }

    const normalized = input.replace(/\//g, '-').replace(/\s+/, 'T');
    const match = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:T(\d{1,2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?)?$/);
    if (!match) return null;

    const [, year, month, day, hour, minute, second, millisecond] = match;
    const dateOnly = typeof hour === 'undefined';
    const utcTimestamp = Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      dateOnly ? (isEnd ? 23 : 0) : Number(hour),
      dateOnly ? (isEnd ? 59 : 0) : Number(minute),
      dateOnly ? (isEnd ? 59 : 0) : Number(second || 0),
      dateOnly ? (isEnd ? 999 : 0) : Number((millisecond || '0').padEnd(3, '0'))
    );

    return utcTimestamp - JST_OFFSET_MINUTES * 60 * 1000;
  };

  const findActiveSchedule = (schedules) => {
    const now = Date.now();

    return schedules.find((schedule) => {
      if (!schedule || !schedule.src) return false;

      const start = parseJstDate(schedule.start);
      const end = parseJstDate(schedule.end, true);

      if (start && now < start) return false;
      if (end && now > end) return false;

      return true;
    });
  };

  const getLogoWrappers = (sectionId, root = document) => {
    if (!sectionId || !root.querySelectorAll) return [];
    return Array.from(root.querySelectorAll(`[data-scheduled-logo-wrapper="${sectionId}"]`));
  };

  const revealLogoWrapper = (wrapper) => {
    wrapper.removeAttribute('data-scheduled-logo-pending');
  };

  const revealSection = (sectionId, root = document) => {
    getLogoWrappers(sectionId, root).forEach(revealLogoWrapper);
  };

  const prepareRevealWhenImageReady = (wrapper, image) => {
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      image.removeEventListener('load', finish);
      image.removeEventListener('error', finish);
      revealLogoWrapper(wrapper);
    };

    image.addEventListener('load', finish, { once: true });
    image.addEventListener('error', finish, { once: true });
    window.setTimeout(finish, 2000);

    return finish;
  };

  const applySchedule = (sectionId, schedule, root = document) => {
    if (!sectionId || !schedule) return;

    getLogoWrappers(sectionId, root).forEach((wrapper) => {
      const image = wrapper.querySelector('img');
      const link = wrapper.closest('a');

      if (image) {
        const reveal = prepareRevealWhenImageReady(wrapper, image);

        if (schedule.srcset) {
          image.srcset = schedule.srcset;
        } else {
          image.removeAttribute('srcset');
        }

        if (schedule.alt) {
          image.alt = schedule.alt;
        }

        image.src = schedule.src;

        if (image.complete) {
          reveal();
        }
      } else {
        revealLogoWrapper(wrapper);
      }

      if (link && schedule.link) {
        link.href = schedule.link;
      }
    });
  };

  const initScheduledLogos = (root = document) => {
    root.querySelectorAll('[data-scheduled-logo-config]').forEach((script) => {
      const sectionId = script.dataset.scheduledLogoConfig;
      let schedules = [];

      try {
        schedules = JSON.parse(script.textContent || '[]');
      } catch (error) {
        revealSection(sectionId, root);
        return;
      }

      const activeSchedule = findActiveSchedule(schedules);
      if (!activeSchedule) {
        revealSection(sectionId, root);
        return;
      }

      applySchedule(sectionId, activeSchedule, root);
    });
  };

  initScheduledLogos();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initScheduledLogos(), { once: true });
  }

  document.addEventListener('shopify:section:load', (event) => {
    initScheduledLogos(event.target);
  });
})();
